import DeselectedCandidates from "./DeselectedCandidates";

export default DeselectedCandidates;
